
<template>
  <!--添加禁用小区-->
  <div>
    <x-addEdit
    apiOrigin="PHP"
    ref="addEdit"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
    :itemLayout="$store.state.modal_ItemLayout"
  >
  <template slot="transfer" slot-scope="{formItem}">
      <a-form-item :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
        <transfer ref="transfer"/>
      </a-form-item>
    </template>
  </x-addEdit>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
import transfer from './transfer.vue';
export default {
  mixins: [fetchSelect],
  components: {
    transfer
  },
  name: 'addDisCommunity',
  data () {
    return {
      formList: [
        {
          label: '所在城市',
          inputType: 'cascader',
          options: [],
          handle: this.getCommunity,
          placeholder: '请选择城市',
          loadData: e => {
            this.regionSelect(0, 'formList', '1,2', e);
          },
          props: ['area_id', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          slot: 'transfer',
          label: '选择小区',
          inputType: 'text',
          options: [],
          handle: '',
          placeholder: '请选择小区',
          titles: ['小区列表', '已选'],
          props: ['community_id', {
            rules: [{required: true, message: '请选择小区'}]
          }]
        }
      ],
      formKey: {
        community_id: undefined
      },
      addParam: {
        url: '/screen_show/blacklist',
        reqHandle: this.addReqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '',
        resHandle: '' // this.detailResHandle
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.regionSelect((data) => {
        this.formList[0].options = data;
      }, 'formList', '1,2');
    },
    /** 获取小区列表 */
    getCommunity (e) {
      this.$refs.transfer.init(e);
    },
    detailResHandle (res) {
      return res;
    },
    addReqHandle (param) {
      delete param.area_id;

      let arealist = this.$refs.transfer && this.$refs.transfer.targetKeys;
      if (arealist.length == 0) {
        this.$message.error('请选择小区');
        return;
      } else {
        param.community_id = arealist.toString();
      }
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
